import { Header } from './Header';
import { Footer } from './Footer';
import { RelatedSites } from '../sections/RelatedSites';

/**
 * Layout 컴포넌트 Props 인터페이스
 * 
 * 레이아웃에 포함될 자식 요소들을 정의합니다.
 */
interface LayoutProps {
  children: React.ReactNode;
}

/**
 * 기본 레이아웃 컴포넌트
 * 
 * 웹사이트의 전체적인 구조를 정의하는 기본 레이아웃입니다.
 * 헤더, 메인 콘텐츠 영역, 관련 사이트, 푸터를 포함하며,
 * 모든 페이지에서 공통으로 사용되는 레이아웃 구조를 제공합니다.
 * 
 * 주요 기능:
 * - 전체 화면 높이 보장 (min-h-screen)
 * - 헤더와 푸터 고정 배치
 * - 메인 콘텐츠 영역 유연한 높이 조절
 * - 관련 사이트 섹션 포함
 * - 반응형 디자인 지원
 */
export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* 웹사이트 헤더 */}
      <Header />

      {/* 메인 콘텐츠 영역 */}
      <main className="flex-1 pb-40 w-full bg-gray-50">
        {children}
      </main>

      {/* 관련 사이트 섹션 */}
      <RelatedSites />

      {/* 웹사이트 푸터 */}
      <Footer />
    </div>
  );
} 